import { useContext, useState } from 'react';
import axios from 'axios';
import { AppContext } from '@/App';
import { DuplicateProjectWarning } from '@/components/DuplicateProjectWarning';

export const ProjectMasterForm = ({ record, projects, onSaved, onCancel }) => {
  const { API } = useContext(AppContext);
  const [name, setName] = useState(record.name || '');
  const [description, setDescription] = useState(record.description || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const save = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    setError('');
    try {
      const payload = { name: name.trim(), description };
      // Use the EXACT same creation handler as Ongoing Projects: no copied defaults.
      if (record.id) await axios.put(`${API}/projects/${record.id}`, payload);
      else await axios.post(`${API}/projects`, payload);
      onSaved();
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Could not save project. Please retry.');
    } finally { setSaving(false); }
  };
  return (
    <form onSubmit={save} className="border-y border-gray-200 py-5 space-y-4" data-testid="master-project-form">
      <h2 className="text-lg font-semibold" data-testid="master-project-form-title">{record.id ? `Edit ${record.id}` : 'New project'}</h2>
      <label className="block text-sm font-medium">Project name
        <input required value={name} onChange={(e) => setName(e.target.value)} disabled={saving}
          data-testid="master-project-name" className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2" />
      </label>
      <label className="block text-sm font-medium">Description
        <textarea value={description} onChange={(e) => setDescription(e.target.value)} disabled={saving}
          data-testid="master-project-description" className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2" rows={3} />
      </label>
      {!record.id && <DuplicateProjectWarning name={name} projects={projects} testId="master-project-duplicate-warning" />}
      {error && <p role="alert" className="text-red-700 text-sm" data-testid="master-project-save-error">{error}</p>}
      <div className="flex gap-3">
        <button disabled={saving || !name.trim()} className="px-4 py-2 bg-indigo-700 text-white rounded-lg disabled:opacity-50 hover:bg-indigo-800 transition-colors" data-testid="master-project-save">{saving ? 'Saving…' : 'Save project'}</button>
        <button type="button" disabled={saving} onClick={onCancel} className="px-4 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors" data-testid="master-project-cancel">Cancel</button>
      </div>
    </form>
  );
};